import createTransporterOrder from './addOrdersToTransporter/createTransporterOrder';
import { newTransporterOrderRequest } from '../../requests';
import { throwTranslatableError } from '@/core';

export default async function addOrdersToTransporter({ commit, dispatch },{
	orders,
	vendor, // transporter
	etd,
	eta,
	despatchOption,
	deliveryOption,
	customDespatchParty,
	customDeliveryParty,
	serviceCode,
	sendEmail,
	freeText,
}) {
	if (!orders || !vendor || !etd) {
		throw new Error('failedToAddOrderToTransporter');
	}

	if (sendEmail && !vendor.email) {
		throw new Error('missingEmailAddress');
	}

	let addedOrders = [];
	for (let order of orders) {
		addedOrders.push(createTransporterOrder(order, vendor, etd, eta, despatchOption, deliveryOption, customDespatchParty, customDeliveryParty, serviceCode));
	}
	if (addedOrders.length > 0) {
		try {
			let response = await newTransporterOrderRequest({ vendor, orders: addedOrders, etd, sendEmail, freeText });
			commit('setTrip', response);
			dispatch('tripSearch/fetchTrips');
			dispatch('orderSearch/refreshOrders', addedOrders.map(x => x.orderId));
			commit('setSelectedGridOrderIds', []);
			commit('setFilteredGridOrderIds', []);
		} catch (e) {
			throwTranslatableError(e, 'failedToAddOrderToTransporter');
		}
	}
}